"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACSkeletonRadioGroup = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable react/react-in-jsx-scope */
var ACSkeletonRadioGroup = function () {
    return ((0, jsx_runtime_1.jsx)("span", { className: "flex items-center flex-wrap gap-2", children: Array(4)
            .fill(0)
            .map(function (_, i) {
            return ((0, jsx_runtime_1.jsx)("span", { className: "apx-ui-shimmer-effect w-[100px] h-[35px] rounded-3xl" }, i));
        }) }));
};
exports.ACSkeletonRadioGroup = ACSkeletonRadioGroup;
